/*
  The fixed sentences a broker reads about scan reports (S2BWB-344). Defined once here and
  imported by the store modules and the attach dialog; the server's own text is never shown.
*/

export const NOT_REACHABLE = "We couldn't reach the server. Check your connection and try again.";
export const SCAN_UPLOAD_FAILED = "The scan report could not be uploaded. Try again.";
export const SCAN_UPLOAD_REFUSED = "We couldn't attach that scan report. Check the file and try again.";
export const SCAN_UPLOAD_TOO_LARGE = "That file is too large. Try a smaller PDF.";
export const SCAN_UPLOAD_NOT_PDF = "Only PDF files can be attached.";
export const SCAN_UPLOAD_TIMEOUT = "The upload took too long. Try again.";
/** The API answered 404: the scan summary is switched off for this submission. */
export const SCAN_UNAVAILABLE = "Scan reports aren't available right now.";

/**
 * One sentence for a failed scan report upload, chosen by what happened. The server's
 * words are only read to tell a non-PDF refusal apart (and only on a 400, 415 or 422);
 * they are never shown. A 404 means the scan summary is off.
 */
export function scanUploadFailureMessage(error, data) {
  if (error && error.code === "ECONNABORTED") return SCAN_UPLOAD_TIMEOUT;
  if (error && !error.response) return NOT_REACHABLE;
  const status = (error && error.response && error.response.status) || 0;
  const body = (error && error.response && error.response.data) || data || {};
  const said = String(body.error || body.message || "");
  if (status === 404) return SCAN_UNAVAILABLE;
  if (status === 413) return SCAN_UPLOAD_TOO_LARGE;
  if (status === 415 || ((status === 400 || status === 422) && /\bpdf\b/i.test(said))) return SCAN_UPLOAD_NOT_PDF;
  if (status >= 400 && status < 500) return SCAN_UPLOAD_REFUSED;
  return SCAN_UPLOAD_FAILED;
}

/** The longest summary a broker can save, in characters. */
export const NARRATIVE_MAX = 20000;
